import { Ionicons } from '@expo/vector-icons';
import { Alert, Pressable, StyleSheet } from 'react-native';

interface ChatAttachmentButtonProps {
  disabled?: boolean;
  accentColor: string;
  onPickFromCamera: () => void;
  onPickFromLibrary: () => void;
}

export function ChatAttachmentButton({
  disabled = false,
  accentColor,
  onPickFromCamera,
  onPickFromLibrary,
}: ChatAttachmentButtonProps) {
  const handlePress = () => {
    Alert.alert('Attach a photo', undefined, [
      { text: 'Take Photo', onPress: onPickFromCamera },
      { text: 'Choose from Library', onPress: onPickFromLibrary },
      { text: 'Cancel', style: 'cancel' },
    ]);
  };

  return (
    <Pressable
      style={({ pressed }) => [
        styles.button,
        { opacity: disabled ? 0.4 : pressed ? 0.6 : 1 },
      ]}
      onPress={handlePress}
      disabled={disabled}
      accessibilityLabel="Attach a photo"
      accessibilityRole="button"
      hitSlop={8}
    >
      <Ionicons name="attach-outline" size={22} color={accentColor} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 6,
  },
});
